
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 40 40","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#D8D8D8","fill-rule":"nonzero","cx":"20","cy":"20","r":"20"}}),_c('path',{attrs:{"d":"M25.74 21.88c.929 2.086 1.246 4.101.953 6.048-3.046 1.128-5.327 1.692-6.845 1.692-1.517 0-3.8-.564-6.848-1.692.003-2.831.272-4.847.807-6.047.8-1.801 10.542-3.128 11.934 0z","stroke":"#CDCDCD","fill":"#6F6F6F"}}),_c('ellipse',{attrs:{"stroke":"#CDCDCD","fill":"#6F6F6F","cx":"19.306","cy":"16","rx":"5.306","ry":"5"}})])])
          )
        }
      }
    